import React from 'react';
import QueryForm from "./QueryForm";
import ExistingQueries from "./ExistingQueries";

function QueryDrawerContent(props) {



    return (
        <div className="d-col gap-15">
            <ExistingQueries config={props.config}/>
            <h3>Create a Query</h3>
            <QueryForm config={props.config} close={props.close}/>
        </div>

    )
}

export default QueryDrawerContent;